/**
 * cn — lightweight className utility.
 * Filters falsy values and joins with a space.
 *
 * Usage:
 *   cn('base-class', isActive && 'active', variant === 'primary' && 'btn--primary')
 */
export function cn(...classes) {
  return classes.filter(Boolean).join(' ')
}
